import User from '../models/user'
import Beat from '../models/beat'
import Soundkit from '../models/soundkit'
import Song from '../models/song'

import PlaylistManager from '../classes/playlistmanager'

import EventTracker from '../classes/EventTracker'
import Error from '../classes/Errors'
import DomainUrlBuilder from '../classes/DomainUrlBuilder'

import checkout from './modules/checkout'
import customDomain from './modules/custom-domain'
import soundkits from './modules/soundkits'
import Vuex from "vuex";
import Vue from "vue/dist/vue.js";
import BeatTapes from "../models/beat-tapes"
import Service from "../models/service";

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        checkout,
        customDomain,
        soundkits
    },
    state: {
        domainUrlBuilder: new DomainUrlBuilder(),
        viewPortWidth: window.innerWidth,
        app: null,
        configure: ab.configure,
        originalConfig: null,
        currentConfig: null,
        currentPage: null,
        changeActiveConfigPanel: false,
        showTour: false,
        pageFullWidthForced: false,

        //############# new configuration ##############//
        newConfigOptions: {
            name: '',
            type: null,
            config: 'template',
            template: null,
            copyConfigId: '',
            default: false
        },
        templates: [],
        //############# new configuration ##############//

        //############# player infos ##############//
        playlistManager: new PlaylistManager(),
        playlists: null,
        lastPlaylist: 0,
        addToPlaylist: {
            beat: false,
            error: false
        },
        playerSlider: null,
        //############# end player ################//

        previousRoute: null,
        singleMusicPageName: null,
        editingConfig: false,
        mobile: false,
        user: new User(ab.user),
        userConfigs: (ab.userConfigs != undefined) ? ab.userConfigs : [],
        genres: [],
        moods: [],
        musicKeys: [],
        tempos: [
            {'.key': '1-60', '.value': '< 61'},
            {'.key': '61-80', '.value': '61 - 80'},
            {'.key': '81-100', '.value': '81 - 100'},
            {'.key': '101-120', '.value': '101 - 120'},
            {'.key': '121-140', '.value': '121 - 140'},
            {'.key': '141-160', '.value': '141 - 160'},
            {'.key': '161-180', '.value': '161 - 180'},
            {'.key': '181-200', '.value': '181 - 200'},
            {'.key': '200-1000', '.value': '200+'},
        ],
        pagesConfigEdit: {
            pageToEdit: null,
            linksNeedUpdating: false
        },
        iconToEdit: null,
        hover: {
            menuItem: false,
            musicContainer: false,
            itemPlayButton: false
        },

        cart: null,

        search: '',
        filters: {
            genre: 0,
            moods: '',
            added: 0,
            order: '',
            tags: '',
            tempo: '',
            keys: '',
        },
        defaultFilters: {
            genre: 0,
            moods: '',
            added: 0,
            order: '',
            tags: '',
            tempo: '',
            keys: '',
        },
        closeFilterBar: false,

        collapseMenu: null,

        itemView: {
            id: null,
            duration: 0
        },

        // checkout states
        // ###############
        // licenses : null,
        /**
         * name @deprecated , replaced by checkout store module
         */
        name : '',
        /**
         * email @deprecated , replaced by checkout store module
         */
        email: '',
        coupon: {
            error: false,
            loading: false,
            message: false,
            code: "",
            discountString: "",
            licenses: null
        },
        player: {
            show: {
                menu: false,
                secondaryMenu: false,
                playlistSlider: false
            },
            playing: false,
            loop : false,
            random : false,
            activeItem: null,
        },
        /**
         * agreedTerms @deprecated , replaced by checkout store module
         */
        agreedTerms : false,
        countries : ab.countries,
        licenses : ab.user.licenses,
        modalLicense : null,

        // Modals
        loginModal: null,
        shareModal: null,
        offerModal: null,
        downloadModal: null,

        shareable: null,
        shareFromPage: null,
        downloadable: null,
        buyableBeat: null,
        offerable: null,
        csrfToken: $("meta[name='csrf-token']").attr("content"),
        loggedInUser: ab.loggedInUser,

        errors: {
            login: new Error(),
            register: new Error(),
            details: {
                name : false,
                email: false
            },
            licenses: false,
            stripe: false
        },
        discoverPlaylist: {
            primary: [],
            primaryLoading: true,
            secondary: [],
            secondaryLoading: true,
            newBeats: [],
            newBeatsLoading: true,
            trendingBeats: [],
            trendingBeatsLoading: true,
            soundkits: [],
            services: [],
            servicesLoading: true,
            soundkitsLoading: true,
            songs: [],
            songsLoading: true,
            beattapes: [],
            beattapesLoading: false
        },
        discoverPageInitialLoad: false,
        eventTracker: new EventTracker(),
        recommendedBeats: [],
        showLicenceContainer: null,
        loadingOverlay: false,
        configLoadingOverlay: false,
        dismissConfigOverlay: false,
        activePackageDiscount: null,
        tidioChatBooting: false,
        tidioChatBootingTimeElapsed: 0,
        cartPopupClicked: false,
        showPackageDiscountsNotice: false,
        popupIsHovered: false,
        userClickedOnBuy: false,
        nameChange: false,
        bugsnagClient: null,
    },
    mutations: {
        updateTidioChatBooting(state, payload) {
            if (state.tidioChatBooting !== payload)
                state.tidioChatBooting = payload;
        },
        tidioChatBootingTimeElapsed(state, payload) {
            state.tidioChatBootingTimeElapsed = payload
        },
        addToDiscoverPlaylist (state, payload) {
            let playlist = state.playlistManager.getPagePlaylist();
            let items

            switch (payload.key) {
                case 'beattapes':
                    items = BeatTapes.makeArray(payload.value)
                    break;
                case 'soundkits':
                    items = Soundkit.makeArray(payload.value)
                    break;
                case 'songs':
                    items = Song.makeArray(payload.value)
                    break;
                case 'services':
                    items = Service.makeArray(payload.value)
                    break
                default:
                    items = Beat.makeArray(payload.value)
                    break;
            }

            state.discoverPlaylist[payload.key] = items
            state.discoverPlaylist[`${payload.key}Loading`] = false

            playlist.emptyPlaylist()

            for (var i in state.discoverPlaylist) {
                playlist.addPlaylistItems(state.discoverPlaylist[i])
            }

        },
        clearDiscoverPlaylist (state) {
            state.discoverPlaylist.primary = []
            state.discoverPlaylist.secondary = []
            state.discoverPlaylist.newBeats = []
            state.discoverPlaylist.trendingBeats = []
            state.discoverPlaylist.soundkits = []
            state.discoverPlaylist.songs = []
            state.discoverPlaylist.beattapes = []
        },
        discoverPageInitialLoad (state, payload) {
            state.discoverPageInitialLoad = payload.load
        },
        toggleLoading(state) {
            state.loadingOverlay = !state.loadingOverlay
        },
        toggleConfigLoading(state) {
            state.configLoadingOverlay = !state.configLoadingOverlay
        },
        dismissConfigOverlay(state) {
            state.dismissConfigOverlay = !state.dismissConfigOverlay
        },
        changeActiveConfigPanel(state, payload) {
            state.changeActiveConfigPanel = payload.panel
        },
        showTour(state, payload) {
            state.showTour = payload.show
        },
        injectUploadedFile (state, payload) {
            state.currentConfig.setUploadedFile(payload.file, payload.key);
        },
        removeUploadedFile (state, payload) {
            state.currentConfig.removeUploadedFile(payload.state, payload.key)
        },
        modalLicense (state, payload) {
            state.modalLicense = payload.modalLicense
        },
        agreedTerms (state, payload) {
            state.agreedTerms = payload.agreedTerms
        },
        name (state, payload) {
            state.name = payload.name
        },
        email (state, payload) {
            state.email = payload.email
        },
        errors (state, payload) {
            if(payload.key == 'name'){
                state.errors.details.name = payload.error;
            }
            if(payload.key == 'email'){
                state.errors.details.email = payload.error;
            }

            if(payload.key == 'licenses'){
                state.errors.licenses = payload.error;
            }

            if(payload.key == 'stripe'){
                state.errors.stripe = payload.error;
            }
        },
        configure(state, payload) {
            state.configure = payload.configure
        },
        previousRoute(state, payload) {
            state.previousRoute = payload.route
        },
        singleMusicPageName(state, payload) {
            state.singleMusicPageName = payload.name
        },
        recommendedBeats(state, payload) {
            state.recommendedBeats = payload.recommendedBeats
        },
        showLicenceContainer(state, payload) {
            state.showLicenceContainer = payload
        },
        clearShowLicenceContainer(state) {
            state.showLicenceContainer = null
        },
        setMoodsAndGenres (state, {moods, genres}) {
            state.moods = moods
            state.genres = genres
        },
        setMusicKeys (state, {musicKeys}) {
            state.musicKeys = musicKeys
        },
        setItemView(state, payload)
        {
            state.itemView = payload
        },
        viewPortWidth (state, payload) {
            state.viewPortWidth = payload.width
        },
        app (state, payload) {
            state.app = payload.app
        },
        setBeatFilters (state, payload) {
            for (var i in payload.filters) {
                state.filters[i] = payload.filters[i]
            }
        },
        closeFilterBar (state, payload) {
            state.closeFilterBar = payload.close
        },
        collapseMenu (state, payload) {
            state.collapseMenu = payload.menu
        },
        originalConfig(state, payload) {
            state.originalConfig = payload.config
        },
        currentConfig(state, payload) {
            state.currentConfig = payload.config
        },
        setConfigParam(state, payload) {
            state.currentConfig[payload.param] = payload.value
        },
        stylesConfig (state, payload) {
            state.currentConfig.stylesConfig = payload.config
        },
        pagesConfig (state, payload) {
            state.currentConfig.pagesConfig = payload.config
        },
        setStylesConfigValue (state, payload) {
            if (payload.valueIndex != null) {
                state.currentConfig.stylesConfig[payload.category][payload.item].value[payload.valueIndex] = payload.style

            } else {
                state.currentConfig.stylesConfig[payload.category][payload.item].value = payload.style
            }
        },
        editingConfig (state, payload) {
            state.editingConfig = payload.editing
        },
        pageToEdit (state, payload) {
            state.pagesConfigEdit.pageToEdit = payload.page
        },
        linksNeedUpdating (state, payload) {
            state.pagesConfigEdit.linksNeedUpdating = payload.update
        },
        hover (state, payload){
            state.hover[payload.element] = payload.hover
        },
        mobile (state) {
            state.mobile = true
        },
        updateConfiguration (state, payload) {
            state.configuration[payload.option] = payload.value
        },
        sharedBeat (state, payload) {
            state.sharedBeat = payload.beat
        },
        cart (state, payload) {
            state.cart = payload.cart
        },
        selectedTab (state, payload) {
            state.selectedTab = payload.tab
        },
        currentPage (state, payload) {
            state.currentPage = payload.page
        },

        //############## player ####################//
        playingTab (state, payload) {
            state.player.playing.tab = payload.tab
        },
        playerLoop (state, payload) {
            state.player.loop = payload.loop
        },
        playerRandom (state, payload) {
            state.player.random = payload.random
        },
        playingItem (state, payload) {
            state.player.playing.item = payload.item
        },
        playingCollection (state, payload) {
            state.player.playing.collection = payload.collection
        },
        playlists (state, payload) {
            state.playlists = payload.playlists
        },
        addPlaylist (state, payload) {
            state.playlists.unshift(payload.playlist)
        },
        lastPlaylist (state, payload) {
            state.lastPlaylist = payload.playlist
        },
        beatAddedToPlaylist (state, payload) {
           state.addToPlaylist.beat = payload.id
        },
        togglePlayerPlaylistSlider (state, payload) {
            state.player.show.playlistSlider = (payload && payload.show != undefined) ? payload.show : !state.player.show.playlistSlider
        },
        playerActive (state, payload) {
            state.player.playing = payload.active
        },
        playerActiveItem (state, payload) {
            state.player.activeItem = payload.activeItem
        },
        playerSlider (state, payload) {
            state.playerSlider = payload.slider
        },
        audioManager (state, payload) {
            state.audioManager = payload.manager
        },
        //############################################
        searchQuery (state, payload) {
            state.search = payload.searchQuery
        },
        filters (state, payload) {
            for (var i in payload.filters) {
                state.filters[i] = payload.filters[i]
            }
        },
        showMenu (state, payload) {
            state.menu.show = payload.show
        },
        soundObject (state, payload) {
            state.player.soundObject = payload.sound
        },
        buyableBeat (state, payload) {
            state.buyableBeat = payload.beat
        },
        offerable (state, payload) {
            state.offerable = payload.offerable
        },
        shareable (state, payload) {
            state.shareable = payload.shareable
        },
        shareFromPage (state, payload) {
            state.shareFromPage = payload.shareFromPage
        },
        downloadable (state, payload) {
            state.downloadable = payload.downloadable
        },
        loginModal (state, payload) {
            state.loginModal = payload.modal
        },
        shareModal (state, payload) {
            state.shareModal = payload.modal
        },
        offerModal (state, payload) {
            state.offerModal = payload.modal
        },
        downloadModal (state, payload) {
            state.downloadModal = payload.modal
        },
        currentSoundkit (state, payload) {
            state.currentSoundkit = payload.kit
        },
        checkoutForm (state, payload) {
            state.checkoutForm = payload.form
        },
        loading (state, payload) {
            state.loading = payload
        },
        coupon (state, payload) {
            for (var i in payload) {
                state.coupon[i] = payload[i]
            }
        },
        loggedInUser (state, payload) {
            state.loggedInUser = payload.user
        },
        loginError (state, payload) {
            for (var i in payload) {
                state.login[i] = payload[i]
            }
        },
        loginSuccess (state, payload) {
            state.login.success = true
            state.login.error = false
            state.login.message = false
        },
        csrfToken (state, payload) {
            state.csrfToken = payload;
        },
        xsrfToken (state, payload) {
            state.xsrfToken = payload.token
        },
        loadMoreInPlaylist (state, payload) {
            state.loadMoreInPlaylist = payload.load
        },
        playlistLoadingComplete (state, payload) {
            state.playlistLoadingComplete = payload.complete
        },
        activeDiscountCollapse(state, payload) {
            state.activePackageDiscount = payload
        },

        //############# new configuration ##############//
        newConfigOptions(state, payload) {
            for (let i in payload) {
                state.newConfigOptions[i] = payload[i]
            }
        },
        templates(state, payload) {
            state.templates = payload.templates
        },
        toggleCartPopupClick(state, payload) {
            if(!payload) {
                state.userClickedOnBuy = false
                state.popupIsHovered = false
            }
            state.cartPopupClicked = payload
        },
        togglePackageDiscountsNotice(state, payload) {
            state.showPackageDiscountsNotice = payload
        },
        togglePopupIsHovered(state, payload) {
            state.popupIsHovered = payload
        },
        setUserClickedOnBuy(state, payload) {
            state.userClickedOnBuy = payload
        },
        pageNameChanged(state, payload) {
            state.nameChange = payload
        },
        //############################################

        pageFullWidthForced(state, payload){
            state.pageFullWidthForced = payload;
        },
        bugsnagClient(state, payload){
            state.bugsnagClient = payload;
        }
    },
    actions: {
        sendGaEvent(context, data) {
            if (typeof ga === "function") {
                ga('player.send', 'event', data.category, data.action, data.label);
            }
        }
    },
    getters:{
        licenses: (state) => {
            var licenses = [];
            for (var i = 0; i < ab.user.licenses.length; i++) {
                var license = ab.user.licenses[i];
                license.position = i;
                licenses.push(license);
            }
            state.licenses = licenses;
            return state.licenses;
        },
        name: (state) => {
            return state.name
        },
        email: (state) => {
            return state.email
        },
        agreedTerms: (state) => {
            return state.agreedTerms
        },
        modalLicense: (state) => {
            return state.modalLicense
        },
        buyerLoggedIn: (state) => {
            return state.loggedInUser ? true : false;
        }

    }
})


